
import { ClientApi } from '@vva/front';

const clientApi = new ClientApi();

export const getPartnerLogo = async (partner: string, email: string): Promise<any> => {
    const response = await clientApi.getData(
        `${window.ENV.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/public/partners/${partner}/info?email=${email}`);
    return response.data;
};